export * from './badge-pill-list.module';
export * from './badge-pill-list.component';
